import React from "react";
import Logo from "components/Logo/Logo";
import SocialsList1 from "components/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import "../../styles/styles.css"


const Footer: React.FC = () => {
 
  return (
    <div className="footer">
      <h2 style={{height:"80px"}} className="center inline-block align-middle text-4xl font-semibold md:text-5xl ">
      <a href="tel:+514-560-3774">514-560-3774</a>
      </h2>
    </div>     
  );
};

export default Footer;
